import React from 'react';
import {classes} from './ViolationsAndPlaceOrderButton.st.css';
import {useControllerProps} from '../Widget/ControllerContext';
import {PlaceOrderButton} from '../PlaceOrderButton/PlaceOrderButton';
import {Violations} from '../Violations/Violations';
import {SkeletonLineWrapper} from '../../../common/components/Skeleton/SkeletonLineWrapper/SkeletonLineWrapper';
import {SkeletonRow} from '../../../common/components/Skeleton/SkeletonRow/SkeletonRow';
import {SkeletonSection} from '../../../common/components/Skeleton/SkeletonSection/SkeletonSection';
import {ViolationSeverity} from '../../../domain/models/checkout/CartSummary/Violation.model';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';

export interface ViolationsAndPlaceOrderButtonProps {
  checkboxesRef?: React.RefObject<HTMLDivElement>;
  paymentWidgetRef?: React.RefObject<HTMLDivElement>;
}

export enum ViolationsAndPlaceOrderButtonDataHook {
  violations = 'ViolationsAndPlaceOrderButtonDataHook.violations',
  Loader = 'ViolationsAndPlaceOrderButtonDataHook.loader',
}

export const ViolationsAndPlaceOrderButton = ({
  checkboxesRef,
  paymentWidgetRef,
}: ViolationsAndPlaceOrderButtonProps) => {
  const {
    checkoutStore: {defaultViolationsToDisplay, cartSummary, isSelectedDeliveryMethodInvalid},
    stepsManagerStore: {shouldShowMemberLoginStep},
  } = useControllerProps();
  const localeKeys = useLocaleKeys();

  const violations = [
    ...defaultViolationsToDisplay,
    ...(isSelectedDeliveryMethodInvalid
      ? [
          {
            severity: ViolationSeverity.error,
            description: localeKeys.checkout.invalidDelivery.error(),
          },
        ]
      : []),
  ];

  return shouldShowMemberLoginStep ? null : (
    <div className={classes.root}>
      <div>
        {cartSummary ? (
          <>
            <Violations dataHook={ViolationsAndPlaceOrderButtonDataHook.violations} violations={violations} />
            <PlaceOrderButton checkboxesRef={checkboxesRef} paymentWidgetRef={paymentWidgetRef} />
          </>
        ) : (
          <SkeletonSection dataHook={ViolationsAndPlaceOrderButtonDataHook.Loader}>
            <SkeletonRow>
              <SkeletonLineWrapper className={classes.skeleton} />
            </SkeletonRow>
          </SkeletonSection>
        )}
      </div>
    </div>
  );
};
